import {Injectable, isDevMode} from '@angular/core';
import {HttpClient, HttpHeaders, HttpParams} from '@angular/common/http';
import {Observable} from 'rxjs/Observable';
import 'rxjs/add/operator/shareReplay';
import 'rxjs/add/observable/throw';
import {ProgressService} from './progress.service';
import {catchError, tap} from 'rxjs/operators';
import {of} from 'rxjs/observable/of';
import {SnackService} from './snack.service';
import {BaseObject} from '../model/Entities/BaseObject';
import {SortInfo} from '../model/Helpers/SortInfo';
import {Filter} from '../model/Helpers/Filter';
import {Pagination} from '../model/Helpers/Pagination';
import {Tools} from '../model/Helpers/Tools';
import {LocalStorageService} from './local-storage.service';
import {ProductContent} from '../model/Entities/ProductContent';
import {environment} from '../environments/environment';

export class BaseService {
    public apiRoot = '';
    // public apiRoot = 'http://localhost/maxstorage';
    // protected betaApiRoot = 'https://maxstoragebeta.oneplace.cz';
    // protected productionApiRoot = 'https://maxstorage.oneplace.cz';


    constructor() {
        this.apiRoot = environment.apiRoot;
    }

    getFiltersUrlQuery(filters: Filter[]) {
        let url = '';

        if (filters.length > 0) {
            url += '?';
            for (let i = 0; i < filters.length; i++) {
                let value = '';

                if (Array.isArray(filters[i].value)) {
                    for (let j = 0; j < (filters[i].value as number[]).length; j++) {
                        value += (j > 0 ? ',' : '') + filters[i].value[j];
                    }
                } else {
                    value = filters[i].value.toString();
                }

                url += Tools.decamelize(filters[i].name) + filters[i].operator + value;

                if (i + 1 < filters.length) {
                    url += '&';
                }
            }
        }

        return url;
    }
}



// WEBPACK FOOTER //
// /app/src/services/base.service.ts